import { AppliedFiltersContext } from "context/AppliedFiltersContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useAppliedFilters = () => {
  return useProviderInitializedContext(AppliedFiltersContext);
};

export { defaultFilters } from "context/AppliedFiltersContext";
